import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Observable, Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoRequisitionTracking } from 'app/shared/models/opening/dto-requisition-tracking.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { OpeningService } from 'app/views/appviews/opening/opening.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IRecruiterComment } from 'app/shared/models/recruitment/recruiter-comment.model';
import { map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DocumentService } from 'app/shared/services/document.service';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { ModalUploadFilesComponet } from '../upload-files/modal-upload-files.component';

@Component({
  selector: 'app-modal-requisition-tracking',
  styleUrls: ['./modal-requisition-tracking.style.scss'],
  templateUrl: './modal-requisition-tracking.template.html',
  encapsulation: ViewEncapsulation.None
})

export class ModalRequisitionTrackingComponet implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formularios */
  private form: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<IDtoRequisitionTracking>;
  private requisitionTracking: IDtoRequisitionTracking;
  private title: string;
  private profile: string;
  private admissionDateTitle: string;
  private hireDateTitle: string;
  /** Catalogos */
  private catalogSources: Observable<ISelect[]>;
  private catalogTrackingStatus: ISelect[];
  private fileName = '';
  private document = {} as IDtoDocument;
  observationOperationList: string[] = [];
  private modalRef: BsModalRef;
  constructor(private bsModalRef: BsModalRef
    , private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private recruitmentService: RecruitmentService
    , private openingService: OpeningService
    , private identityService: IdentityService
    , private spinner: NgxSpinnerService
    , private documentService: DocumentService
    , private datePipe: DatePipe
    , private modalService: BsModalService) {
    this.initializeForm();
  }
  ngOnInit(): void {
    this.catalogSources = this.recruitmentService.getCatalogSources();
    this.recruitmentService.getCatalogTrackingStatus().subscribe(t => {
      this.catalogTrackingStatus = t.filter(item => !item.text.includes('Laborando en Red') && !item.text.includes('Baja'));
      this.observationOperationList = this.requisitionTracking.operationObservation.split(',').map(obs => obs.trim());
    });
    this.catalogSources.subscribe(x => {
      this.requisitionTracking.trackingStatusId = this.requisitionTracking.trackingStatusId.toString();
      this.requisitionTracking.recruitmentSourceId = this.requisitionTracking.recruitmentSourceId != undefined ? this.requisitionTracking.recruitmentSourceId.toString() : null;
      this.requisitionTracking.hireDate = this.requisitionTracking.hireDate != undefined ? new Date(this.requisitionTracking.hireDate) : null;
      this.requisitionTracking.admissionDate = this.requisitionTracking.admissionDate != undefined ? new Date(this.requisitionTracking.admissionDate) : null;
      this.form.patchValue(this.requisitionTracking);

      if (this.profile != 'Operaciones') {
        this.form.get('operationObservation').setValidators(null);
        this.form.get('operationObservation').updateValueAndValidity();
      }
    });
    // this.getLatesDocumentVersion();
    if (this.requisitionTracking.recruitmentSourceId != null){
    this.catalogSources.pipe(
      map(x =>
        x.filter(user => user.id === this.requisitionTracking.recruitmentSourceId)[0]
      )
    ).subscribe(
      x => this.requisitionTracking.recruitmentSource = x.text.toString()
    )};
    if (this.requisitionTracking.hireDate != null){
    let date = new Date(this.requisitionTracking.hireDate).toLocaleDateString('es-mx', { year:"numeric", month:"long", day:"numeric"})
      this.hireDateTitle = date;};
      if (this.requisitionTracking.admissionDate != null){
    let date1 = new Date(this.requisitionTracking.admissionDate).toLocaleDateString('es-mx', { year:"numeric", month:"long", day:"numeric"})
      this.admissionDateTitle = date1;};
      this.onClose = new Subject();
  }
  private initializeForm() {
    this.form = this.formBuilder.group({
      recruitingObservations: [null, [Validators.required, Validators.maxLength(500)]],
      recruitmentSourceId: [null, [Validators.required]],
      interviewObservations: [null, [Validators.required, Validators.maxLength(500)]],
      hireDate: [null, [Validators.required]],
      admissionDate: [null, [Validators.required]],
      finalRecruitmentObservation: [null, [Validators.required, Validators.maxLength(500)]],
      trackingStatusId: [null, [Validators.required]],
      operationObservation: [null, [Validators.maxLength(1000)]],
      newOperationbservation: [null],
      admissionDateTitle: null,
      hireDateTitle: null,
      trackingStatusTitle: null,
      recruitmentSourceTitle: null
    });
  }
  private submit(): void {
    if (this.form.valid) {
      this.updateTrackingStatusJobCandidate();
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
      this.configGeneral.touchedControls(this.form);
    }
  }
  private update(): void {
    const dto = this.form.value as IDtoRequisitionTracking;
    this.requisitionTracking.trackingStatusId = dto.trackingStatusId;
    this.requisitionTracking.recruitmentSourceId = dto.recruitmentSourceId;
    this.requisitionTracking.hireDate = dto.hireDate;
    this.requisitionTracking.admissionDate = dto.admissionDate;
    this.requisitionTracking.recruitingObservations = dto.recruitingObservations;
    this.requisitionTracking.interviewObservations = dto.interviewObservations;
    this.requisitionTracking.finalRecruitmentObservation = dto.finalRecruitmentObservation;
    this.requisitionTracking.operationObservation = dto.operationObservation;
    this.openingService.updateRequisitionTracking(this.requisitionTracking)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            let t = this.catalogTrackingStatus.filter(r => r.id == this.requisitionTracking.trackingStatusId)[0];
            this.requisitionTracking.trackingStatus = t.text;
            this.addModuleLog();
            this.onClose.next(this.requisitionTracking);
            this.bsModalRef.hide();
          }
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private updateTrackingStatusJobCandidate(): void {
    let dto = {} as IRecruiterComment;
    dto.trackingStatusId = this.form.value.trackingStatusId;
    dto.jobCandidateId = this.requisitionTracking.jobCandidateId;
    this.recruitmentService.updateTrackingStatusJobCandidate(dto)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.update();
          }
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private updateOperationObservation(): void {
    let dto = {} as IDtoRequisitionTracking;
    dto.id = this.requisitionTracking.id;
    dto.operationObservation = this.form.value.operationObservation;
    this.openingService.updateOperationObservationRequisitionTracking(dto)
      .subscribe(
        (x) => {
          this.configGeneral.notificationSuccessError(x)
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private addModuleLog(): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'RequisitionTrackings';
    dto.module = 'RequisitionDetail';
    dto.action = 'tracking';
    dto.registryAffectedId = this.requisitionTracking.id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }
  getDisabledValueRecruitment() {
    if (this.profile == 'Operaciones') {
      return true;
    }
  }

  getDisabledValue() {
    if (this.profile == 'Reclutamiento'){
      return true
    };

    if (this.requisitionTracking.operationObservation == null || this.requisitionTracking.operationObservation == '') {
      return false;
    }
    else {
      return true;
    }
  }
  // private onFileChange(event) {
  //   event.value = '';
  // }
  // private handleFileInput(files: FileList) {
  //   //this.fileName = files.item(0).name;
  //   this.upload(files);
  // }
  // private upload(files: FileList): void {
  //   if (files != undefined) {
  //       this.spinner.show();
  //       let document = {} as IDtoDocument;
  //       const fileName = files.item(0).name;
  //       let sp = fileName.split('.').pop();
  //       let fileNameNew = `${this.requisitionTracking.jobCandidateId}_SeguimientoRequisición_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
  //       document.fileName = fileNameNew;
  //       this.fileName = fileNameNew;
  //       document.referenceId = this.requisitionTracking.id;
  //       document.folder = 'Requisition';
  //       document.module = 'RequisitionTrackingsOperation';
  //       document.name = "SeguimientoRequisiciónOperacion";
  //       document.acceptDuplicate = true;
  //       const file = files.item(0);
  //       this.documentService.addDocument(document, file).subscribe((res) => {
  //           if (res.isCorrect === true) {
  //               this.configGeneral.newToast('Éxito', res.message, 'success');
  //               this.document = res.data as IDtoDocument;
  //               this.fileName = this.document.fileName;
  //               //this.addModuleLog(this.customer.id, 'addContract');
  //           } else {
  //               this.configGeneral.newToast('Error', res.message, 'error');
  //           }
  //           this.spinner.hide();
  //       },
  //       (errMessage) => {
  //           this.spinner.hide();
  //           this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
  //       });
  //   }
  // }
  // private downloadFile(): void {
  //   this.documentService.downloadFile(this.document.id).subscribe((res) => {
  //       if (res.isCorrect === true) {
  //           const file = res.data as any;
  //           const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
  //           saveAs(blob, file.fileDownloadName);
  //           //this.addModuleLog(this.document.id, 'downloadFile');
  //           this.spinner.hide();
  //       } else {
  //           this.configGeneral.newToast('Error', res.message, 'error');
  //           this.spinner.hide();
  //       }
  //   },
  //   (errMessage) => {
  //       this.spinner.hide();
  //       this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
  //   });
  // }
  // private getLatesDocumentVersion(): void {
  //   console.log('Documento', this.document);
  //   this.documentService.getLatesDocumentVersion(this.requisitionTracking.id, 'SeguimientoRequisiciónOperacion').subscribe(res => {
  //       if (res.data != undefined){
  //         this.document = res.data as IDtoDocument;
  //         this.fileName = this.document.fileName;
  //       }
  //   })
  // }
  private openModalUploadFile(): void {
    const initialState = {
        title: 'Subir archivos',
        jobCandidateId: this.requisitionTracking.jobCandidateId,
        id: this.requisitionTracking.id,
        name: 'SeguimientoRequisiciónOperacion',
        folder: 'Requisition',
        module: 'RequisitionTrackingsOperation',
        type: 'UploadFile'
    };
    this.modalRef = this.modalService.show(ModalUploadFilesComponet
        , Object.assign({ initialState }
            , this.configGeneral.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
        if (result) {
        // this.submitSentApproval(result);
        }
    });
  }
  private getLatesDocumentVersion(): void {
    console.log('Documento', this.document);
    this.documentService.getLatesDocumentVersion(this.requisitionTracking.id, 'SeguimientoRequisiciónOperacion').subscribe(res => {
        if (res.data != undefined){
          this.document = res.data as IDtoDocument;
          this.fileName = this.document.fileName;
        }
    })
  }
  addObservation(): void {
    const currentObservation = this.form.get('operationObservation') ? this.form.get('operationObservation').value : '';
    const newObservation = this.form.get('newOperationbservation').value? this.profile + ': ' + this.form.get('newOperationbservation').value : '';

    if (newObservation) {
      const updatedObservation = currentObservation
        ? `${currentObservation}, ${newObservation}`
        : newObservation;
      this.form.get('operationObservation').setValue(updatedObservation);
      this.form.get('newOperationbservation').reset();
      this.observationOperationList = updatedObservation.split(',').map(obs => obs.trim());
    }
  }
}
